export const EVENT_ACCOUNT_UPDATE = 'account.update'
export const EVENT_ACCOUNT_CREATE = 'account.create'
